/* global angular, moment */
/**
 * Created by lari on 07/06/2017.
 */


(function () {
  'use strict';
  angular.module('vcutils.doctor')
    .component('doctorsearch', {
      restrict: 'E',
      bindings: {
        parentsave: '&?',
        editinplace: '@?'
      },
      template: `
        <div class="form-group">
          <div class="input-group">
                <input type="text" class="form-control" tabindex="0"
                   ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                   placeholder="Arztsuche ...."
                   ng-model="vm.asyncSelected"
                   typeahead-on-select="$parent.$dismiss();vm.showdoctor($item, $model, $label)"
                   uib-typeahead="doctor as doctor.fname for doctor in vm.getDoctors($viewValue)"
                   typeahead-loading="loadingNames"
                   typeahead-no-results="noResults">
            <span class="input-group-btn">
              <button type="submit"
                      ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        
        
        <i ng-show="loadingNames" class="fa fa-spin fa-spinner"></i>
        <div ng-show="noResults">
          <i class="fa fa-warning"></i> Kein Arzt gefunden
          <span class="btn btn-success" ng-click="vm.addDoctor()" ng-hide="vm.error" ng-show="vm.parentsave">Neuen Arzt eingeben</span>
          <span ng-click="vm.addDoctor()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Arzt konnte nicht angelegt werden!</span>
        </div>
        
        <div ng-show="(vm.editinplace === true || vm.editinplace === 'true') && vm.showedit">
          <doctoreditor doctor="vm.doctor"></doctoreditor>
        </div>
        
        
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Doctor', 'DoctorHelper',
        function ($log, Doctor, DoctorHelper) {
          let vm = this;
          vm.save = save;
          vm.showdoctor = showdoctor;

          vm.getDoctors = getDoctors;
          vm.addDoctor = addDoctor;
          vm.editDoctor = DoctorHelper.editDoctor;
          vm.$onInit = function () {
            vm.newdoctor = {};
            vm.lastdoctor = angular.copy(vm.doctor);
            vm.lastdoctorref = angular.copy(vm.doctorref);
          };

          function addDoctor() {
            $log.debug('debug - doctorsearch addDoctor called');
            DoctorHelper.addDoctor(function (doctor) {
              $log.debug('debug: handle newly create doctor: ', doctor);
              vm.doctor = {};
              vm.doctor.name = doctor.name;
              vm.doctor.short = doctor.short;
              vm.doctor.fname = doctor.fname;
              vm.doctor._id = doctor._id;
              vm.doctorref = doctor._id;
              vm.asyncSelected = doctor.short;
              $log.info('vm.doctor before parentsave: ', vm.doctor);
              if (angular.isDefined(vm.parentsave) && angular.isFunction(vm.parentsave)) {
                vm.parentsave({doctor: vm.doctor});
              } else {
                vm.doctor.$save();
              }
            }, function (err) {
              vm.error = true;
              $log.error(err);
            });
          }

          // typeahead doctor search backend query
          function getDoctors(val) {
            return Doctor.$searchahead({
              query: val,
              fields: ['lastname', 'firstname', 'institute', 'speciality']
            }).$asPromise().then(function (response) {
              return response.map(function (doctor) {
                let fname = DoctorHelper.fname(doctor);
                doctor.fname = fname;
                delete vm.error;
                return doctor;
              });
            });
          }

          // typeahead doctor search action
          function showdoctor($item, $model, $label) {
            /* jshint unused:false */
            /* eslint "no-unused-lets": [2, {"args": "none"}] */
            vm.doctor = $model;
            vm.doctorref = $model._id;
            delete vm.asyncSelected;
            if (vm.editinplace === true || vm.editinplace === 'true') {
              vm.doctor = $model;
              vm.doctorref = $model._id;
              vm.showedit = true;
            }
            else {
              vm.doctor = $model;
              let doctorresult = {};
              doctorresult._id = vm.doctor._id;
              doctorresult.fname = DoctorHelper.fname(vm.doctor);
              doctorresult.fulldoc = vm.doctor;
              vm.parentsave({doctor: doctorresult});
            }
          }

          function save() {
            if (!angular.equals(vm.doctor, vm.lastdoctor) || !angular.equals(vm.doctorref, vm.lastdoctorref)) {
              vm.lastdoctor = angular.copy(vm.doctor);
              if (angular.isDefined(vm.parentsave) && angular.isFunction(vm.parentsave)) {
                vm.parentsave({doctor: vm.doctor});
              } else if (angular.isDefined(vm.doctor.$save) && angular.isFunction(vm.doctor.$save)) {
                vm.doctor.$save();
              }
            }
          }


        }] // controller
    }); // component

// klammerfriedhof
}());
